const testimonials = [
  {
    name: "Jennifer M.",
    location: "Kennesaw, GA",
    rating: 5,
    text: "I'm a professor at Kennesaw State and had a conference in Barcelona in 10 days. My passport had expired months ago and I completely forgot. Fast Passport Center got me processed and my passport in hand in 7 days. I shipped from the UPS Store on Cherokee Street overnight. Incredible service.",
    service: "Emergency Passport",
  },
  {
    name: "Brian T.",
    location: "Acworth, GA",
    rating: 5,
    text: "We planned a family cruise to the Caribbean and realized my son needed a passport. I had no idea both parents had to be there or where to go. Fast Passport Center sent us a perfect checklist, told us exactly which clerk to visit in Marietta, and handled the rest. Got it in 10 days.",
    service: "Child Passport",
  },
  {
    name: "Michelle K.",
    location: "Woodstock, GA",
    rating: 5,
    text: "My passport was damaged after a house flood two weeks before a work trip to London. I was devastated. Fast Passport Center walked me through the replacement process, told me exactly what to send, and got my new passport in 8 days. I shipped from home via FedEx — never had to drive anywhere.",
    service: "Damaged Passport Replacement",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function KennesawTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Kennesaw Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Kennesaw, Acworth, Woodstock, and Cobb County who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}